// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var authContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center")
    ]);

var flatAuthBlock = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.flexDirection("row"),
      BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(0)))])
    ]);

var stackedAuthBlock = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
            BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
            BsCssJs$PrezzeeRibbon.justifyContent("flexStart"),
            BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(16)),
            BsCssJs$PrezzeeRibbon.borderTopWidth(BsCssJs$PrezzeeRibbon.px(1)),
            BsCssJs$PrezzeeRibbon.borderTopStyle("solid"),
            BsCssJs$PrezzeeRibbon.borderTopColor(Theme__Color$PrezzeeRibbon.Personal.paleDivider),
            BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.flexGrow(1)])
          ])]);

var headerAuth = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [BsCssJs$PrezzeeRibbon.display("none")])]);

var Styles = {
  authContainer: authContainer,
  flatAuthBlock: flatAuthBlock,
  stackedAuthBlock: stackedAuthBlock,
  headerAuth: headerAuth
};

function TopNavigationBar__AuthContainer(props) {
  var className = props.className;
  var authMenu = props.authMenu;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      greaterThanOrEqual: "rbLargeDesktop",
                      children: JsxRuntime.jsx("div", {
                            children: authMenu,
                            className: Classnames([
                                  flatAuthBlock,
                                  headerAuth
                                ])
                          }),
                      className: Classnames([
                            authContainer,
                            className$1
                          ])
                    }),
                JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                      lessThan: props.authMenuLowerBreakpoint,
                      children: JsxRuntime.jsx("div", {
                            children: authMenu,
                            className: stackedAuthBlock
                          })
                    })
              ]
            });
}

var make = TopNavigationBar__AuthContainer;

export {
  Styles ,
  make ,
}
/* authContainer Not a pure module */
